import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Typography,
  Grid,
} from '@material-ui/core';

import PieChartIcon from '@material-ui/icons/PieChart';
import useStyles from './styles';

const BinaryTable = ({ teleauditKpis }) => {
  const { t } = useTranslation();
  const styles = useStyles();

  return (
    <>
      <List
        subheader={
          <Grid container>
            <Grid item>
              <Box
                mt={4}
                mb={4}
                display="flex"
                direction="row"
                alignItems="center"
              >
                <PieChartIcon color="primary" />
                <Typography variant="h2">
                  {' '}
                  {t('teleaudit.binaryTable.metrics')}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        }
      >
        {teleauditKpis
          ? Object.keys(teleauditKpis.binary).map((item) => (
              <Grid key={teleauditKpis.binary[item].KpiDetail.name} className={styles.listItem}>
                <ListItem dense>
                  <ListItemText
                    id={teleauditKpis.binary[item.name]}
                    align="left"
                    primary={teleauditKpis.binary[item].KpiDetail.name}
                  />
                </ListItem>
              </Grid>
          ))
          : null}
      </List>
    </>
  );
};

export default BinaryTable;
